import { updateUserProfile } from "@/services/org";
import store from "@/store";
import { localStorageBoolean, localStorageKey } from "@/utils/constants";
import Utils from "@/utils/utilities";
import { load } from "recaptcha-v3";
import userService from "@/services/user/userService";
import get from "lodash/get";
import { productFruits } from "product-fruits";
import { showErrorAPI } from "@/services/apiRoutes";
import { UserRoute } from "@/services/apiRoutes/routes";
export default {
  namespaced: true,

  state() {
    return {
      isAuthenticated: false,
      preSession: false,
      currentOrg: {},
      orgsList: [],
      salutation: [],
      isCloseModalProfile: true,
      currentUser: {},
      urlAvatar: null,
      userProfile: {},
      activeCallApi: true,
      isErrorAnauth: false,
    };
  },

  getters: {},
  mutations: {
    initialise: (state: any) => {
      if (localStorage.getItem("isAuthenticated")) {
        state.isAuthenticated = true;
      }

      if (localStorage.getItem(localStorageKey.currentOrgData)) {
        state.currentOrg = JSON.parse(
          localStorage.getItem(localStorageKey.currentOrgData) || "{}",
        );
      }
    },
    SET_USER_AUTHENTICATED: (state: any) => {
      state.isAuthenticated = true;
      localStorage.setItem("isAuthenticated", localStorageBoolean.true);
    },
    setCurrentUser: (state: any, setCurrentUser) => {
      state.currentUser = setCurrentUser;
    },
    setIsCloseModalProfile: (state: any, isCloseProfile) => {
      state.isCloseModalProfile = isCloseProfile;
    },
    SET_USER_UNAUTHENTICATED: (state: any) => {
      state.isAuthenticated = false;
      store.dispatch("Org/removeOrgStore");
      // store.dispatch("Navigation/setMenuOpen");
      // store.dispatch("Navigation/setChevronActive", true);
      store.dispatch("Org/setCurrentOrgPlanDetails", {});
      store.dispatch("Sharing/resetSharingStore").then();
      localStorage.removeItem("isAuthenticated");
      localStorage.removeItem(localStorageKey.currentOrgData);
      localStorage.removeItem(localStorageKey.rootChecklistReportId);
      localStorage.removeItem(localStorageKey.checklistReportId);
      localStorage.removeItem(localStorageKey.recaptcha);
      localStorage.removeItem(localStorageKey.currentUserData);
      localStorage.removeItem(localStorageKey.isOrgPlanDetails);
      localStorage.removeItem(localStorageKey.cyberReportDisplayOption);
      localStorage.removeItem(localStorageKey.showDashboardInfo);
      localStorage.removeItem(localStorageKey.productFruitsInitialized);
      localStorage.removeItem(localStorageKey.sharingPagingRoadmap);
      localStorage.removeItem(localStorageKey.sharingPagingQuickwin);
      localStorage.removeItem(
        localStorageKey.vendorManageIncludeHomeOrgTemplate,
      );
      localStorage.removeItem(localStorageKey.vendorManageShowArchivedTemplate);
      sessionStorage.clear();
    },
    SET_PRE_SESSION: (state: any) => {
      state.preSession = true;
    },
    SET_ACTIVE_CALL_API: (state: any, isCallApi) => {
      state.activeCallApi = isCallApi;
    },
    UNSET_PRE_SESSION: (state: any) => {
      state.preSession = false;
    },
    SET_CURRENT_ORG: (state: any, org: any) => {
      state.currentOrg = org;
      localStorage.setItem(localStorageKey.currentOrgData, JSON.stringify(org));
    },
    SET_ORGS_LIST: (state: any, orgs: any) => {
      state.orgsList = orgs;
    },
    UPDATE_USER_PROFILE: async (state: any, payload: any) => {
      if (!payload.data.languageId || payload.data.languageId === "null") {
        return;
      }
      // reset product fruit if language change
      const currentLang = localStorage.getItem(localStorageKey.languageId);
      if (currentLang !== payload.data?.languageId) {
        (window as any).productFruits.services?.destroy;
        const currentUserData = JSON.parse(
          localStorage.getItem(localStorageKey.currentUserData) || "{}",
        );
        (window as any).productFruits?.services?.destroy();
        productFruits.init(
          process.env.VUE_APP_PRODUCT_FRUIT_WORDSPACE_CODE || "",
          Utils.getISOLanguageCode(payload.data?.languageId),
          {
            username: `${currentUserData.firstName} ${currentUserData.lastName}`,
          },
        );
        localStorage.setItem(
          localStorageKey.productFruitsInitialized,
          localStorageBoolean.true,
        );
      }
      try {
        const res = await updateUserProfile(payload);
        if (res) {
          if (!localStorage.getItem(localStorageKey.recaptcha)) {
            await Utils.getV3Recaptcha().then(async (finalKey: any) => {
              const captchKey = finalKey;
              const recaptcha = await load(`${captchKey}`, {
                autoHideBadge: true,
              });
              await recaptcha.execute("submit").then(async (token) => {
                localStorage.setItem(localStorageKey.recaptcha, token);
                await store.dispatch("LanguagePicker/setLanguages", token);
              });
            });
          } else {
            await store.dispatch(
              "LanguagePicker/setLanguages",
              localStorage.getItem(localStorageKey.recaptcha),
            );
          }
        }
      } catch (error) {
        showErrorAPI(error, UserRoute.profileUpdate);
      }
    },
    SET_LIST_SALUTATION: (state: any, value) => {
      state.salutation = value;
    },
    SET_AVATAR_CURRENT: (state: any, value) => {
      state.urlAvatar = value;
    },
    SET_USER_PROFILE: (state: any, value) => {
      state.userProfile = value;
    },
    setErrorAnauth: (state: any, value) => {
      state.isErrorAnauth = value;
    },
  },
  actions: {
    authenticateUser: ({ commit }) => {
      commit("SET_USER_AUTHENTICATED");
    },
    unauthenticateUser: ({ commit }) => {
      commit("SET_USER_UNAUTHENTICATED");
    },
    setActiveCallApi: ({ commit }, isCallApi: boolean) => {
      commit("SET_ACTIVE_CALL_API", isCallApi);
    },
    setPreSession: ({ commit }) => {
      commit("SET_PRE_SESSION");
    },
    unsetPreSession: ({ commit }) => {
      commit("UNSET_PRE_SESSION");
    },
    setCurrentOrg: ({ commit }, org: any) => {
      commit("SET_CURRENT_ORG", org);
    },
    setOrgsList: ({ commit }, orgs: any) => {
      commit("SET_ORGS_LIST", orgs);
    },
    updateUserProfile: async ({ commit }, paypoad: any) => {
      await commit("UPDATE_USER_PROFILE", paypoad);
    },
    getSalutations: async ({ commit }) => {
      try {
        const res = await userService.getSalutations();
        const data: any = get(res, "data.data", {} as any);
        commit("SET_LIST_SALUTATION", data || []);
        return res;
      } catch (error) {
        showErrorAPI(error, UserRoute.getSalutations);
        return error;
      }
    },
    resetMfaAuthenApp: async () => {
      try {
        return await userService.resetMfaAuthenApp();
      } catch (error) {
        return error;
      }
    },
    getUserProfile: async ({ commit }, id) => {
      try {
        const res = await userService.getUserProfile(id);
        const data: any = get(res, "data.data", {} as any);
        commit("SET_USER_PROFILE", data || []);
      } catch (error) {
        return error;
      }
    },
  },
};
